import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@trg/utils';
import type { SubCategory, Category } from '../api';

export interface MenuState {
  isMenuOpen: boolean;
  selectedCategory: Category | null;
  selectedSubCategory: SubCategory | null;
  selectedChildCategory: SubCategory | null;
}

export interface MenuAction {
  setMenuOpen(open: boolean): void;
  setSelectedCategory(category: Category | null): void;
  setSelectedSubCategory(subCategory: SubCategory | null): void;
  setSelectedChildCategory(childCategory: SubCategory | null): void;
}

export type MenuStore = MenuState & MenuAction;

function findChildCategory(subCategory?: SubCategory | null) {
  return subCategory?.subCategories.find(
    ({ subCategories }) => subCategories.length
  );
}

const useMenuStoreBase = create<MenuStore>()(
  devtools(
    (set, get) => ({
      isMenuOpen: false,
      selectedCategory: null,
      selectedSubCategory: null,
      selectedChildCategory: null,
      setMenuOpen(open) {
        set({ isMenuOpen: open });
      },
      setSelectedCategory(category) {
        const subCategory = category?.subCategories?.[0];
        const childCategory = findChildCategory(subCategory);
        set({
          selectedCategory: category,
          selectedSubCategory: subCategory,
          selectedChildCategory: childCategory,
        });
      },
      setSelectedSubCategory(subCategory) {
        const childCategory = findChildCategory(subCategory);
        set({
          selectedSubCategory: subCategory,
          selectedChildCategory: childCategory,
        });
      },
      setSelectedChildCategory(childCategory) {
        set({ selectedChildCategory: childCategory });
      },
    }),
    {
      name: 'header',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export const useMenuStore = createSelectors(useMenuStoreBase);
